const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export interface Tweet {
  id: string;
  tweetId: string;
  text: string;
  likes: number;
  retweets: number;
  replies: number;
  createdAt: string;
}

export interface FetchTweetsResponse {
  success: boolean;
  count: number;
  tweets: Tweet[];
  message: string;
}

export const tweetService = {
  async fetchUserTweets(accessToken: string, userId: string): Promise<FetchTweetsResponse> {
    const response = await fetch(`${API_BASE_URL}/api/tweets/fetch`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        accessToken,
        userId,
        maxResults: 500,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch tweets');
    }

    return await response.json();
  },
};
